<template>
  <header>
    <div class="menu">
      <router-link :to="'/'" tag="div"
      ><img
          alt="David Cannon logo"
          class="logo"
          src="../assets/davidcannon-logo-new.svg"
      /></router-link>
      <div class="hamburger-toggle">
        <button :class="{'active': menuIsOpen}" class="hamburger-icon" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div :class="{'active': menuIsOpen}" class="hamburger-panel" @click="toggleMenu"></div>
        <MainNavigation class="hamburger-menu" @clicked="toggleMenu"></MainNavigation>
      </div>
    </div>
  </header>
</template>

<script>
import MainNavigation from "./MainNavigation";

export default {
  name: "AppHeader",
  components: {MainNavigation},
  data() {
    return {
      menuIsOpen: false,
      scrollY: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    });
  },
  methods: {
    toggleMenu() {
      this.fixBody();
      this.menuIsOpen = !this.menuIsOpen;
    },
    fixBody() {
      const body = document.body;

      if (!this.menuIsOpen) {
        this.scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        body.style.position = 'fixed';
        body.style.top = `-${this.scrollY}`;
        if (document.body.clientHeight > window.innerHeight) {
          body.style.overflowY = 'scroll'
        }
      } else {
        body.style.position = '';
        body.style.top = '';
        body.style.overflowY = 'auto'
        window.scrollTo(0, parseInt(this.scrollY || '0'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-bottom: 1px solid #f2f2f2;
  z-index: 5;
}

.menu {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 1rem;

  @media screen and (min-width: 769px) {
    padding: 0 2rem;
  }

  .logo {
    width: 125px;
    max-width: 50vw;
    padding: 0.5rem 1rem 0.5rem 0;
    cursor: pointer;
  }
}

.hamburger {
  &-menu {
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 15rem;
    height: 100vh;
    position: fixed;
    right: 0;
    text-align: center;
    transition-timing-function: cubic-bezier(10, 2, 3, 1);
    transform: translateX(100%);
    top: 0;
    padding: calc(65px + 2rem) 2rem;
    z-index: 20;
    transition-duration: 0.5s;

    @media screen and (max-width: 480px) {
      width: 100vw;
    }
  }

  &-panel {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(#2c2c2c, 0.3);
    opacity: 0;
    transition-duration: 0.5s;
    transition-timing-function: cubic-bezier(10, 2, 3, 1);
    pointer-events: none;
    z-index: 5;

    &.active {
      opacity: 1;
      pointer-events: auto;
    }
  }

  &-icon {
    position: relative;
    height: 44px;
    width: 44px;
    right: 0;
    top: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    background: none;
    border: none;
    cursor: pointer;
    padding: 13px 0 13px 18px;
    outline: none;
    z-index: 25;

    > span {
      height: 1px;
      width: 100%;
      background-color: #000;
      transition: 0.5s;
      z-index: 100;
    }

    &.active {
      ~ .hamburger-menu {
        transform: translateX(0rem);
      }

      > span:nth-child(1) {
        transform: translateY(8.5px) rotate(45deg);
      }

      > span:nth-child(2) {
        opacity: 0;
      }

      > span:nth-child(3) {
        transform: translateY(-8.5px) rotate(-45deg);
      }
    }
  }
}
</style>


